export default "__VITE_ASSET__DeMb3ZSv__"